import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        tag: "",
        sortType: "",
        sortValue: ""
    },
    reducers: {
        setTagFilter(state, action) {
            state.tag = action.payload;
        },
        setSortParams(state, action) {
            state.sortType = action.payload.sortType;
            state.sortValue = action.payload.sortValue;
            // Si el filtro es por tag, actualizamos también el estado 'tag' para compatibilidad.
            if (action.payload.sortType === 'tag') {
                state.tag = action.payload.sortValue;
            } else if (action.payload.sortType === 'search') {
                // Si es una búsqueda, limpiamos el filtro de tag
                state.tag = "";
            }
        },
        clearTagFilter(state) {
            state.tag = "";
        },
    },
});

export const { setTagFilter, setSortParams, clearTagFilter } = filterSlice.actions;
export default filterSlice.reducer;